<template>
  <el-form :model="warehouseForm" :rules="rules" ref="warehouseForm" label-width="15%" class="demo-warehouseForm" v-loading.body="fetchLoding">
    <el-form-item :label="generateCustomizeString('warehouseName')" prop="name">
      <el-input v-model="warehouseForm.name"></el-input>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('warehouseAddress')" prop="address">
      <el-input v-model="warehouseForm.address"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button v-if="isEdit" type="primary" @click="submitForm('warehouseForm')" plain>{{generateCustomizeString('update')}} </el-button>
      <el-button v-if="!isEdit" type="primary" @click="submitForm('warehouseForm')">{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultWarehouse = {
  name: '',
  address: ''
}

export default {
  name: 'WarehouseDetail',

  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      warehouseForm: Object.assign({}, defaultWarehouse),
      fetchLoding: false,
      rules: {
        name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    submitForm(formName) {
      if (this.isEdit) {
        // update
        this.updateWarehouse()
      } else {
        // create
        this.createWarehouse()
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    fetchWarehouse() {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: 'warehouse/' + this.$route.params.warehouseId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            for (const i in this.warehouseForm) {
              this.warehouseForm[i] = res.data[i]
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    createWarehouse() {
      var data = {
        name: this.warehouseForm.name,
        address: this.warehouseForm.address
      }
      request({
        url: 'warehouse',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })

            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.replace({ name: 'Warehouse' })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updateWarehouse() {
      var data = {
        name: this.warehouseForm.name,
        address: this.warehouseForm.address
      }
      request({
        url: 'warehouse/' + this.$route.params.warehouseId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$router.replace({ name: 'Warehouse' })
          } else {
            this.$message.error()
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    }
  },
  created() {
    if (this.isEdit) {
      this.fetchWarehouse()
    } else {
      this.warehouseForm = Object.assign({}, defaultWarehouse)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-warehouseForm {
  padding: 50px 50px 0px 50px;
}
</style>
